import phoneVerification from './phoneVerification.json';

export { phoneVerification };
